   async function getCart() {
        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();
            return cart;
        } catch (error) {
            console.error("Error fetching cart:", error);
            return null;
        }
        }


document.addEventListener('DOMContentLoaded', function() {
    const productForms = document.querySelectorAll('.product-form');

    productForms.forEach(function(form) {
        const productHandle = form.id.replace('product-form-', '');
        const variantSelect = document.getElementById('variant-select-' + productHandle);
        const frequencySelect = document.getElementById('frequency-select-' + productHandle);
        const addToCartButton = document.getElementById('add-to-cart-' + productHandle);
        const oneTimePriceElement = document.getElementById('one-time-price-' + productHandle);
        const oneTimeComparePriceElement = document.getElementById('one-time-compare-price-' + productHandle);
        const subscribePriceElement = document.getElementById('subscribe-price-' + productHandle);
        const subscribeComparePriceElement = document.getElementById('subscribe-compare-price-' + productHandle);

        var formattedPrice = "{{ product.price | money }}";
        let priceText = (new DOMParser()).parseFromString(formattedPrice, 'text/html').body.textContent;
        let matches = priceText.match(/(^\D*\s*)([0-9.,]+)(\s*\D*$)/);
        let currencyPrefix = "";
        let currencySuffix = "";

        function updatePrices() {
            const selectedOption = variantSelect.options[variantSelect.selectedIndex];
            const oneTimePrice = selectedOption.getAttribute('data-variant-price');
            const oneTimeComparePrice = selectedOption.getAttribute('data-compare-at-price');
            const subscribePrice = selectedOption.getAttribute('data-variant-price-sub');
            const subscribeComparePrice = selectedOption.getAttribute('data-compare-at-price-sub');

            oneTimePriceElement.textContent = `${currencyPrefix}${oneTimePrice}${currencySuffix}`;
            oneTimeComparePriceElement.innerHTML = oneTimeComparePrice != "" ? `<s>${currencyPrefix}${oneTimeComparePrice}${currencySuffix}</s>` : '';

            subscribePriceElement.textContent = `${currencyPrefix}${subscribePrice}${currencySuffix}`;
            subscribeComparePriceElement.innerHTML = subscribeComparePrice != "" ? `<s>${currencyPrefix}${subscribeComparePrice}${currencySuffix}</s>` : '';
        }

        variantSelect.addEventListener('change', function() {
            updatePrices();
        });

        document.querySelectorAll('input[name="purchase-option-' + productHandle + '"]').forEach(input => {
            input.addEventListener('change', function() {
                // frequencySelect is a hidden input; no display toggling needed
            });
        });

        // addToCartButton.addEventListener('click', function(event) {
        //     event.preventDefault();
        //     addToCartButton.setAttribute('disabled', 'disabled');
        //     addToCartButton.textContent = 'Adding to Cart...';

        //     const variantId = variantSelect.value;
        //     const quantity = 1;

        //     const formData = new FormData();
        //     formData.append('id', variantId);
        //     formData.append('quantity', quantity);

        //     if (document.querySelector('input[name="purchase-option-' + productHandle + '"]:checked').value === 'subscribe') {
        //         const frequencyId = frequencySelect.value;
        //         formData.append('selling_plan', frequencyId);
        //     }

        //     console.log('Form submission data:', formData);

        //     fetch('/cart/add.js', {
        //         method: 'POST',
        //         body: formData,
        //         headers: {
        //             'X-Requested-With': 'XMLHttpRequest'
        //         }
        //     })
        //     .then(response => response.json())
        //     .then(data => {
        //         if (data.status === 422) {
        //             console.error(data.message);
        //         } else {
        //             if (typeof Shopify.onItemAdded === 'function') {
        //                 Shopify.onItemAdded(data, true);
        //             } else {
        //                 console.error('Shopify.onItemAdded function is not defined.');
        //             }
        //         }
        //     })
        //     .catch(error => {
        //         console.error("There was an error adding the product to the cart:", error);
        //     })
        //     .finally(() => {
        //         addToCartButton.removeAttribute('disabled');
        //         addToCartButton.textContent = 'Add to Cart';
        //     });
        // });

     

        addToCartButton.addEventListener('click', async function(event) {
            event.preventDefault();
            addToCartButton.setAttribute('disabled', 'disabled');
            addToCartButton.textContent = 'Adding to Cart...';

            const variantId = variantSelect.value;
            const freeProductId = "42345430843440";
            let random =  Math.floor(Math.random() * 10000)
            let sellingPlanId = null;
            const purchaseOption = document.querySelector('input[name="purchase-option-' + productHandle + '"]:checked');
            if (purchaseOption && purchaseOption.value === 'subscribe') {
                sellingPlanId = frequencySelect.value;
            }
            const cart = await getCart();
            const checkFreebottel = cart.items.some(item => item.id === 42345430843440);
            const items = [];
           
            if (sellingPlanId && parseInt(variantId) === 42220551929904 && checkFreebottel===false) {
                items.push({ id: variantId, quantity: 1, selling_plan: sellingPlanId, properties: { "__FreeBundle": `__random${random}` }});
                items.push({ id: freeProductId, quantity: 1, properties: { "__FreeBundle": `__random${random}` } });
            } else if (sellingPlanId) {
                items.push({ id: variantId, quantity: 1, selling_plan: sellingPlanId });
            } else {
                items.push({ id: variantId, quantity: 1 });
            }
            const payload = { items };


            console.log('Form submission data:', payload);
            fetch('/cart/add.js', {
                method: 'POST',
                body: JSON.stringify(payload),
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.status === 422) {
                    console.error(data.message);
                } else {
                    if (typeof Shopify.onItemAdded === 'function') {
                        data.items.forEach(item => Shopify.onItemAdded(item, true));
                    } else {
                        console.error('Shopify.onItemAdded function is not defined.');
                    }
                }
            })
            .catch(error => {
                console.error("There was an error adding the products to the cart:", error);
            })
            .finally(() => {
                addToCartButton.removeAttribute('disabled');
                addToCartButton.textContent = 'Add to Cart';
            });
        });

        updatePrices();
        variantSelect.dispatchEvent(new Event('change'));
    });
});